import styled from 'styled-components'
import React from 'react'
import { Label, SubLabel } from './Text'
import theme from '../utils/theme'

const LabelFieldContainer = styled.div`

  display: flex;
  flex-direction: ${ props => props.direction || 'column' };

  .required {
    color: ${ theme.palette.red };
  }

  .optional {
    color: ${ theme.palette.blue };
  }

  ${ props => props.direction === 'column' ? '' : 'align-items: center;' }

  .label {
    ${ props => props.direction === 'column' ? 'margin-bottom: 5px' : 'margin-right: 10px' };
  }

  .underline {
    width: 62px;
    height: 2px;
    background-color: ${ theme.palette.blue };
    margin-bottom: 10px;
  }

  &.simple-underline {
    .label {
      text-decoration: underline;
    }
  }

`
const LabelField = ({ label, subLabel, children, direction = 'column', className = '', subLabelUnderline,
                      optional, required, ...props }) => {
  return <LabelFieldContainer direction={ direction } className={ 'field ' + className } { ...props } >
    { label && <Label className={ 'label' }>
      { !optional && !required && <div>{ label }</div> }
      { optional && <div>{ label } - <span className="optional">Facultatif</span></div> }
      { required && <div>{ label } - <span className="required">Obligatoire</span></div> }
      { subLabel && <SubLabel>{ subLabel }</SubLabel> }
    </Label> }
    { subLabelUnderline && <div className="underline"/> }
    { children }
  </LabelFieldContainer>
}

export default LabelField
